// Escala numérica del 1 al 5 (tipoControlId = 2)
// ============
import React, { useState, useEffect } from 'react';
import classes from '../Preguntas.css';

// Las opciones se muestran de 1 a 5 según su número, sin importar el orden en que vengan de la API
// (el link del mail cuenta los índices al revés). Si una opción no es numérica, toma su posición.
const numeroDeOpcion = (opcion, indice) => {
  const n = Number(String(opcion.opcion ?? '').trim());
  return Number.isFinite(n) ? n : indice + 1;
};

const colorDeNumero = (n) => {
  if (n <= 2) return classes.rojo;
  if (n === 3) return classes.ambar;
  return classes.verde;
};

export default function PreguntaEscala({
  PreguntasOpciones,
  valorDefault = [],
  numeroPregunta,
  onChangeRespuesta,
  onElegir,
  esObligatoria
}) {
  // Mismo formato que PreguntaMultiselect con selección única: [[id, label]]
  const [selectedValues, setSelectedValues] = useState(Array.isArray(valorDefault) ? valorDefault : []);

  // Sincroniza con el valorDefault si cambia
  useEffect(() => {
    const nuevoValor = Array.isArray(valorDefault) ? valorDefault : [];
    if (nuevoValor[0]?.[0] !== selectedValues[0]?.[0]) {
      setSelectedValues(nuevoValor);
    }
  }, [valorDefault]);

  useEffect(() => {
    onChangeRespuesta({
      numeroPregunta,
      tieneContenido: selectedValues.length > 0,
      contenido: selectedValues,
      esObligatoria
    });
  }, [selectedValues]);

  const elegir = (opcion) => {
    if (opcion.id !== selectedValues[0]?.[0]) {
      setSelectedValues([[opcion.id, opcion.opcion]]);
    }
    onElegir?.();
  };

  const opciones = (PreguntasOpciones ?? [])
    .map((opcion, indice) => ({ opcion, numero: numeroDeOpcion(opcion, indice) }))
    .sort((a, b) => a.numero - b.numero);

  return (
    <div className={classes.escala}>
      <span className={`${classes.lbl} ${classes.lblMin}`}>Nada satisfecho/a</span>
      {opciones.map(({ opcion, numero }) => {
        const seleccionada = selectedValues[0]?.[0] === opcion.id;
        return (
          <button
            key={opcion.id}
            type="button"
            className={`${colorDeNumero(numero)} ${seleccionada ? classes.sel : ''}`}
            aria-pressed={seleccionada}
            aria-label={String(numero)}
            onClick={() => elegir(opcion)}
          >
            {numero}
          </button>
        );
      })}
      <span className={`${classes.lbl} ${classes.lblMax}`}>Muy satisfecho/a</span>
    </div>
  );
}
